<script setup lang="ts">
import { ref } from 'vue'
import { VueDatePicker } from '@vuepic/vue-datepicker';
import FileDownloadBtn from "@/components/Files/DownloadButton.vue"
import '@vuepic/vue-datepicker/dist/main.css'
import { ja } from 'date-fns/locale'
import i18n from "@/lang/i18n";

const props = defineProps<{
  showFlash: (message: string, type: string, fadeout: boolean) => {value: any}
}>()

document.title = i18n.global.t('pages.dataLinkage.title')
const downloadType = "App\\Services\\Csv\\Exports\\DataLinkageService"

const selectDate = ref(new Date())

const addRequestParams = (params:any) => {
  params['select_date'] = selectDate.value.toLocaleDateString()
  return params
}

</script>

<template>
  <div class="d-flex" style="min-height: 45vw;">
    <div class="content p-4 w-100">
      <div class="d-flex justify-content-between mb-8">
        <h4 class="card-title mt-0">
          {{ i18n.global.t('pages.dataLinkage.title') }}
        </h4>
      </div>
      <div>
        <div class="d-flex flex-column col-4">
          <span class="small">
            {{ i18n.global.t('pages.dataLinkage.date') }}
          </span>
          <VueDatePicker
            :locale="ja"
            v-model="selectDate"
            :formats="{ input: 'yyyy/MM/dd' }"
            auto-apply
            :close-on-auto-apply="true"
            :clearable="false"
          />
        </div>
        <div class="d-flex justify-content-end mt-3">
          <FileDownloadBtn
            :showable="true"
            btnClass="exec-btn mt-0 ml-1"
            :btnName="i18n.global.t('common.downloadBtn')"
            :type="downloadType"
            :addRequestParams="addRequestParams"
          />
        </div>
      </div>
    </div>
  </div>
</template>
